import { CellFn } from "@/graphHandling/graphTypes";
import { CellId } from "@/processes/CellId";

const currentCellId = CellId.INITIALIZE_LISATIEDOT;

export const update_lisatiedot: CellFn = async (
  storeFunctions,
  intl,
  payload
) => {
  if (!intl || !payload) {
    console.warn("Parametri intl puuttuu.");
    return false;
  }

  storeFunctions.addModification(currentCellId, payload?.changeProps);

  return true;
};
